module.exports = __webpack_public_path__ + "images/img-latest.jpg?d23226d";


//////////////////
// WEBPACK FOOTER
// ./assets/component/document/images/img-latest.jpg
// module id = 332
// module chunks = 0